<div class="embed-responsive embed-responsive-16by9">
	<p> {{videoUri}}</p>
	<div class="embed-inner embed-responsive-item">
		<iframe width="560" height="315" [src]="videoUri | bypassSecurityTrust : 'resourceUrl'" frameborder="0" 
		allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
		allowfullscreen></iframe>
	</div>
</div>